import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/portraits/with_sunglasses.jpg'
import _imports_1 from './assets/icons/instagram.png'
import _imports_2 from './assets/icons/linkedin.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("title", null, "My app", -1)
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "first-header-content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Présentation")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Projets")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Compétences")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Curiculum Vitae")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Loisirs")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Contact")
const _hoisted_10 = { class: "footer" }
const _hoisted_11 = { class: "container" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" © 2021 - PLR Conseil ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Accueil")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.instagram.com/paulolafoudre/?hl=fr",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img_footer",
    src: _imports_1
  })
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.linkedin.com/in/paul-larsonneur-9923111a4/",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img_footer",
    src: _imports_2
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Burger = _resolveComponent("Burger")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NavigationMenu = _resolveComponent("NavigationMenu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "logo",
            class: "picture-profile",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.goToAccueil()))
          }),
          _createElementVNode("h1", null, _toDisplayString($data.currentPageTitle()), 1)
        ]),
        _createVNode(_component_Burger)
      ]),
      _createVNode(_component_NavigationMenu, { class: "animate__slideInLeft" }, {
        default: _withCtx(() => [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/about",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.navigateTo('Présentation')))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/projects",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.navigateTo('Projets')))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/skills",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.navigateTo('Compétences')))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/curiculum-vitae",
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.navigateTo('Curiculum Vitae')))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/loisirs",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.navigateTo('Loisirs')))
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/contact",
                onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.navigateTo('Contact')))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_router_view, { style: {"height":"90vh"} }),
    _createElementVNode("footer", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("p", null, [
          _hoisted_12,
          _createVNode(_component_router_link, {
            to: "/",
            onClick: _cache[7] || (_cache[7] = ($event: any) => ($options.navigateTo('Accueil')))
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          })
        ]),
        _hoisted_14,
        _hoisted_15
      ])
    ])
  ], 64))
}